module.exports = __webpack_public_path__ + "static/store-hero-2fe9bdd3bf183c0c8a0328a0e50c03c7.jpg";